import React from "react"
import { renderAccountDialog } from "@hg/one-account"

import { ISubPageProps } from "../../context"
import PageRegistry from "."

export const LoginView: React.FC<ISubPageProps> = (props) => {
    return (
        <div>
            {renderAccountDialog((renderAccountDialogProps) => {
                return <PageRegistry {...props} {...renderAccountDialogProps} />
            })}
        </div>
    )
}
